import PlaylistCard from './PlaylistCard';

export default PlaylistCard;
